/* istanbul ignore file */
import { MarkerClusterer } from '@googlemaps/markerclusterer';

import { UntypedFormGroup } from '@angular/forms';

import { environment } from '../../../../../environments/environment';
import { FilterMenuOptions, KHMapMarker } from '../../../../models';
import { MapPin } from '../../../../models/map-pin-model';
import { MapLayerEnum } from '../../../../shared/enums';
import { MapPinColor } from '../../../../shared/enums/logic-builder';
import { MAP_DEFAULTS } from './../../../../shared/constants/map-constants';

export class SiteMapLogicServiceModel {
    dataLayersMap: Map<string, google.maps.Data[]> = new Map<string, google.maps.Data[]>();
    mapFilterVisible = false;
    mapFilterForm?: UntypedFormGroup;
    mapFilterMenuOptions: FilterMenuOptions = new FilterMenuOptions();
    mapLoading = true;
    map?: google.maps.Map;
    mapProperties: google.maps.MapOptions = {
        mapTypeControl: false,
        center: MAP_DEFAULTS.DEFAULT_MAP_CENTER,
        zoom: MAP_DEFAULTS.DEFAULT_MAP_ZOOM,
        minZoom: MAP_DEFAULTS.DEFAULT_MAP_MIN_ZOOM,
        mapTypeId: MapLayerEnum.RoadMap,
        fullscreenControl: true,
        fullscreenControlOptions: {
            position: google.maps.ControlPosition?.RIGHT_BOTTOM ?? 9
        },
        mapId: environment.googleMaps.mapIds.streetLabelsNoPOI
    };

    latitudeLongitudeBounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
    markerCluster?: MarkerClusterer;
    allMapPins: MapPin[] = [];
    filteredMapPins: MapPin[] = [];
    markers: KHMapMarker[] = [];
    pinnedInfoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();
    infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();
    marker?: KHMapMarker;
    mapPin?: MapPin;
    expandedLayersMenu = false;
    mapLayersForm?: UntypedFormGroup;
    pinnedInfoWindowContent?: HTMLElement;
    currentInfoWindowContent?: HTMLElement;
    evaluatedMapPinColorsBySiteId: Map<string, MapPinColor> = new Map<string, MapPinColor>();
    lastCenteredPinSiteId: string | null = null;
    mapTypeToRevert: MapLayerEnum = MapLayerEnum.RoadMap;
    mapCenterToRevert: google.maps.LatLng | null = null;
    mapZoomToRevert: number | null = null;
}
